var React = require('react');

function UpgradeCheckmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFBD05","d":"M9.728 1.215a.795.795 0 00-1.154.071L3.938 6.911 1.327 4.657a.795.795 0 00-1.15.137.934.934 0 00.128 1.237L3.526 8.81c.144.122.324.19.507.19a.79.79 0 00.611-.296l5.149-6.249a.923.923 0 00.205-.638.892.892 0 00-.27-.602z"}));
}

UpgradeCheckmark.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10"};

module.exports = UpgradeCheckmark;

UpgradeCheckmark.default = UpgradeCheckmark;
